import React from "react";
import { useInventoryTransfer } from "../../../../../hooks/inventory/useInventoryTransfer";
import FormModal from "../../../../Modals/FormModal";
import TransferInfoSection from "../TransferDetail/Sections/TransferInfoSection";
import TransferBranchesSection from "../TransferDetail/Sections/TransferBranchesSection";
import TransferFlowSection from "../TransferDetail/Sections/TransferFlowSection";
import AuditSection from "../TransferDetail/Sections/AuditSection";

const InventoryTransferReverseModal: React.FC = () => {
  const {
    handlerReverse,
    showReverseModal,
    form,
    closeReverseModal,
  } = useInventoryTransfer();

  if (!form) return null;

  const canReverse = form.status === "CONFIRMED";

  return (
    <FormModal
      isOpen={showReverseModal}
      onClose={closeReverseModal}
      title="Revertir Traslado"
      maxWidth="max-w-4xl"
      zIndex='front'
    >
      <div className="space-y-8 px-2 py-4">
        <TransferInfoSection
          details={form.details}
          reason={form.reason}
          status={form.status}
        />

        <TransferBranchesSection
          origin={form.originBranchName}
          destination={form.destinationBranchName}
        />

        <TransferFlowSection detail={form} />

        <AuditSection detail={form} />
      </div>

      {/* ------------------------------------------------------------ */}
      {/* BOTONES */}
      {/* ------------------------------------------------------------ */}
      <div className="mt-6 flex justify-end gap-3">

        {/* Cerrar */}
        <button
          type="button"
          onClick={closeReverseModal}
          className="inline-flex rounded bg-[#637381] px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>

        {/* Revertir */}
        {canReverse && (
          <button
            type="button"
            onClick={() => handlerReverse(form.id)}
            className="inline-flex rounded bg-[#DC3545] px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
          >
            Revertir
          </button>
        )}
      </div>
    </FormModal>
  );
};

export default InventoryTransferReverseModal;
